import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { LinkItem } from '../link-item';

@Component({
  selector: 'app-link-item-create',
  templateUrl: './link-item-create.component.html',
  styleUrls: ['./link-item-create.component.css']
})
export class LinkItemCreateComponent implements OnInit {

  linkForm: FormGroup;
  sentSuccessfully = false;
  tooBigFile = false;

  @ViewChild('inputFile') myInputVariable!: ElementRef;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService
  ) {
    this.linkForm = this.builder.group({
      name: [null, Validators.required],
      url: [null, Validators.required],
      image: null
    });
   }

  ngOnInit() {
  }

  sendForm(){
    this.sentSuccessfully = false;
    let link = new LinkItem(
      this.linkForm.value.name.trim(),
      this.linkForm.value.url.trim(),
      null,
      null,
      this.linkForm.value.image
    );
    this.httpService.postLinkItem(link).subscribe(res => {
      console.log("success");
      this.sentSuccessfully = true;
      this.linkForm.get("name")!.setValue(null);
      this.linkForm.get("url")!.setValue(null);
      this.linkForm.get("image")!.setValue(null);
      this.myInputVariable.nativeElement.value = "";
    });
  }

  validateImageFile(file: File): boolean {
    let fileSize = file.size;
    if (fileSize > 8388608) {
      console.log("file too big");
      this.tooBigFile = true;
      return false;
    }
    else {
      return true;
    }
  }

  handleFileInput(event: any) {
    this.tooBigFile = false;
    const reader = new FileReader();
    if (event.target.files && event.target.files[0]) {
      let selectedFile = event.target.files[0];

      if(this.validateImageFile(selectedFile)){
        reader.readAsDataURL(selectedFile);

        reader.onload = () => {
          let pictures = reader.result!.toString().split(",");
          this.linkForm.patchValue({
            image: pictures[1]
          });
        };
      } else {
        this.linkForm.patchValue({
          picture: null
        });
      }
    }
  }

}
